import { useState, useEffect } from 'react';

const CURRENT_VERSION = "2025.10.14.CRITICAL.FIX.V3";

export const useVersionCheck = () => {
  const [needsRefresh, setNeedsRefresh] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Add timestamp to avoid caching
        const response = await fetch(`/version.json?t=${Date.now()}`);
        const text = await response.text();
        
        // Try to parse as JSON first
        let version;
        try {
          const data = JSON.parse(text);
          version = data.version;
        } catch (e) {
          // If not JSON, treat as plain text (old format)
          version = text.trim();
        }
        
        if (version !== CURRENT_VERSION) {
          console.log(`Version mismatch detected. Current: ${CURRENT_VERSION}, Server: ${version}`);
          setNeedsRefresh(true);
        }
      } catch (error) {
        console.log('Version check failed:', error);
      }
    };

    // Check immediately
    checkVersion();
    
    // Check every 30 seconds
    const interval = setInterval(checkVersion, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const forceRefresh = () => {
    // Clear all caches
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    // Clear local storage
    localStorage.clear();
    sessionStorage.clear();
    
    // Force hard reload
    window.location.reload(true);
  };

  return { needsRefresh, forceRefresh };
};

export const VersionChecker = () => {
  const { needsRefresh, forceRefresh } = useVersionCheck();

  if (!needsRefresh) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#ff6b6b',
      color: 'white',
      padding: '12px',
      textAlign: 'center',
      zIndex: 9999
    }}>
      A new version is available. Please refresh to get the latest updates.
      <button 
        onClick={forceRefresh}
        style={{
          marginLeft: '10px',
          padding: '5px 10px',
          backgroundColor: 'white',
          color: '#ff6b6b',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Refresh Now
      </button>
    </div>
  );
};